/**
 * NumericValue — une valeur numérique formatée (montant, nombre, pourcentage, date) rendue dans du JSX
 * (UPT-2111 Q-03, Q-04).
 *
 * `<bdi dir="ltr">` isole la valeur de la phrase voisine et la lit de gauche à droite : dans une interface arabe
 * (RTL), « 1 240 000,00 € » sans isolation s'affiche « € 000,00 240 1 ». Les chiffres sont tabulaires (colonnes
 * alignées sur leurs unités) et la valeur ne se coupe jamais.
 *
 * L'alignement n'est PAS décidé ici : le conteneur pose `text-end` quand la valeur doit se coller à la fin de sa
 * colonne. Pour une chaîne confiée à une grille (cellClass), voir `ui-bidi-isolate` dans le design system.
 */
import type { ReactNode } from 'react';
import { cn } from '@/uptk/core/lib/utils';
import { NUMERIC_VALUE_CLASSES } from '@/uptk/core/utils/numericDisplay';

export type NumericValueProps = {
  children: ReactNode;
  className?: string;
};

export function NumericValue({ children, className }: Readonly<NumericValueProps>) {
  return (
    <bdi dir="ltr" className={cn(NUMERIC_VALUE_CLASSES, className)}>
      {children}
    </bdi>
  );
}

export default NumericValue;
